module.exports = __webpack_public_path__ + "autoalert-logo-lincoln.5507be40c620784f092c.png";